import React, { Component } from 'react'
import _ from 'lodash'
import styled from 'styled-components'

import { isActiveTab } from 'broker/util/helper'
import { HEADER_TEXT_COLOR } from 'broker/util/constants'
import { ConnectedMobileLink } from 'broker/views/components/MobileNav/MobileLink'

const HeadWrapper = styled.div`
  min-height: 68px;
  height: fit-content;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 rgba(182,182,182,0.5);

  color: ${HEADER_TEXT_COLOR};
  font-family: "Circular", sans-serif;
  padding: 40px 40px 0;
  margin-top: 2px;
`

const HeadContent = styled.div`
  height: fit-content;
  width: 100%;
  margin: 0 auto;
  max-width: 1370px;
  display: flex;
  flex-direction: row;
  align-content: flex-end;
`
//  max-width: 936px;

const TabLink = styled(ConnectedMobileLink)`
  font-size: 14px;
  font-family: "Circular", sans-serif;
  font-weight: 500;
  ${props => props.active ?
    'color: #0588DD;' :
    'color: #B4B3B3;'
  }
  line-height: 18px;
  text-align: center;

  :hover, :focus, :visited {
    text-decoration: none;
  }
`

const LinkWrapper = styled.div`
  margin: 0 20px;
  padding-bottom: 8px;

  ${props => props.active ?
    'border-bottom: 5px solid #0588DD;' :
    ''
  }

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }
`

const TabsList = styled.div`
  list-style: none;
  display: flex;
  flex-direction: row;
  margin: 0;
`

class LeadsWrapper extends Component {
  render() {
    const tabs = [
      {label: 'Lead Sources', value: '/leads/sources'},
      {label: 'Leads', value: '/leads/list'},
    ]

    return (
      <div>
        <HeadWrapper>
          <HeadContent>
            <TabsList>
            {_.map(tabs, (t, idx) => (
              <LinkWrapper active={isActiveTab(t.value)} key={idx}>
                <TabLink key={idx} label={t.label} value={t.value} active={isActiveTab(t.value)} />
              </LinkWrapper>
            ))}
            </TabsList>
          </HeadContent>
        </HeadWrapper>
        {this.props.children}
      </div>
    )
  }
}

export default LeadsWrapper
